<template>
  <el-dialog title="逾期申请"
             center
             v-loading="loading"
             :visible.sync="dialogVisible">
    <el-form :model="form"
             label-width="80px">
      <el-form-item label="逾期原因">
        <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  v-model="form.MEMO"
                  placeholder="填写逾期原因"></el-input>
      </el-form-item>
      <el-form-item label="延长时长">
        <el-col :span="11">
          <el-input-number v-model="form.DELAYNUM"
                           :min="1"></el-input-number>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-select v-model="form.DELAYUNIT"
                     placeholder="请选择">
            <el-option label="分钟"
                       value="0"> </el-option>
            <el-option label="小时"
                       value="1"> </el-option>
            <el-option label="天"
                       value="2"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="addDelay"
                 type="primary">提交</el-button>
      <el-button @click="dialogVisible=false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from "../../../util/auth";
import { DelayTask, GetTaskTypeById } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  data() {
    return {
      dialogVisible: false,
      form: { MEMO: "", DELAYUNIT: "1", DELAYNUM: 1 },
      mainId: "",
      mainType: 0,
      loading: false,
      mainInstance: "",
      originTime: null,
      delayType: 0
    };
  },
  methods: {
    loadTask(newValue, typeIndex) {
      this.form = { MEMO: "", DELAYUNIT: "1", DELAYNUM: 1 };
      this.delayType = typeIndex;
      console.log(newValue);
      if (newValue) {
        //获取任务类型，判断他是否需要延期审批
        GetTaskTypeById(newValue.TASKTYPE).then(data => {
          console.log(data);
          if (this.delayType === 0) {
            this.form.DELAYNUM = data.PROCCESSHOUR;
            this.originTime = newValue.OVERTIME;
          } else {
            //获取响应时间
            this.form.DELAYNUM = data.RESPONSEHOUR;
            this.originTime = newValue.RESPONSEENDTIME;
          }
          this.mainId = newValue.ID;
          this.mainInstance = newValue.INSTANCE;
          this.mainName = newValue.TASKNAME;
          this.mainType = 0;
        });
        this.dialogVisible = true;
      }
    },
    loadWorkPlan(newValue) {
      if (newValue) {
        this.form.DELAYNUM = 1;
        this.originTime = newValue.ENDTIME.Value;

        this.mainId = newValue.ID;
        this.mainInstance = "";
        this.mainName = newValue.NAME;
        this.mainType = 1;
        this.dialogVisible = true;
      }
    },
    //添加任务延期
    addDelay() {
      if (this.form) {
        this.loading = true;
        let delayTime = new Date();
        var t_s = delayTime.getTime();
        switch (this.form.DELAYUNIT) {
          case "0":
            delayTime.setTime(t_s + 1000 * 60 * this.form.DELAYNUM);
            break;
          case "1":
            delayTime.setTime(t_s + 1000 * 60 * 60 * this.form.DELAYNUM);
            break;
          case "2":
            delayTime.setTime(t_s + 1000 * 60 * 60 * 24 * this.form.DELAYNUM);
            break;
        }
        delayTime = this.datetimeFormater(delayTime);

        let delayInfo = {
          MAINID: this.mainId,
          MAINTYPE: this.mainType,
          MAININSTANCE: this.mainInstance,
          TASKNAME: this.mainName,
          ORIGINENDTIME: this.originTime,
          DELAYTIME: delayTime,
          DELAYTYPE: this.delayType,
          MEMO: this.form.MEMO,
          DELAYNUM: this.form.DELAYNUM,
          DELAYUNIT: this.form.DELAYUNIT,
          CREATETIME: this.datetimeFormater(new Date()),
          CREATEUSERID: cookieUser.userId,
          CREATEUSERID: cookieUser.userId,
          CREATEUSERNAME: cookieUser.realName,
          CREATEDEPTID: cookieUser.departmentId,
          CREATEDEPTNAME: cookieUser.departmentName,
          CREATECOMPANYID: cookieUser.organizationId,
          CREATECOMPANYNAME: cookieUser.organizationName
        };
        console.log(delayInfo);
        DelayTask(delayInfo).then(result => {
          this.loading = false;
          if (result.ResultCode > 0) {
            this.$message.success("延期成功");
            this.$emit("refershSource");
          } else {
            this.$message.error(result.MsgInfo);
          }
          this.dialogVisible = false;
        });
      }
    },
    datetimeFormater(delayTime) {
      return (
        delayTime.getFullYear() +
        "-" +
        (delayTime.getMonth() + 1) +
        "-" +
        delayTime.getDate() +
        " " +
        delayTime.getHours() +
        ":" +
        delayTime.getMinutes() +
        ":" +
        delayTime.getSeconds() +
        ""
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>